import React, { useEffect, useState } from 'react'
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
Font,
  Image,
} from '@react-pdf/renderer'
//@ts-ignore
import font from '../../assets/fonts/OpenSauceSans-Bold.ttf'
import { DateTime } from 'luxon'
import { formatPipe } from '../../utils/utils'

import { IFoodOrder } from 'safe'


const PdfFoodOrder: React.FC<{order: IFoodOrder, tenantInfo: any}> = ({order, tenantInfo}) => {
  Font.register({
    family: 'Open Sans',
    fonts: [{ src: font }],
  })

  const styles = StyleSheet.create({
    page: {
      padding: 15,
      fontSize: 8,
      fontFamily: 'Open Sans',
    },
    header: {
      textAlign: 'center',
      marginBottom: 10,
    },
    restaurantName: {
      fontSize: 12,
      fontWeight: 'bold',
      marginBottom: 2,
    },
    ruc: {
      fontSize: 8,
      marginBottom: 10,
    },
    divider: {
      borderBottomWidth: 1,
      borderBottomColor: 'black',
      marginBottom: 10,
    },
    orderInfo: {
      textAlign: 'center',
      marginBottom: 15,
    },
    orderNumber: {
      fontSize: 10,
      fontWeight: 'bold',
      marginBottom: 2,
    },
    tableInfo: {
      fontSize: 9,
      marginBottom: 10,
    },
    itemsContainer: {
      marginTop: 10,
    },
    itemRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: 3,
    },
    itemName: {
      flex: 1,
    },
    itemQuantity: {
      marginLeft: 10,
    },
    observations: {
      marginTop: 15,
      fontSize: 7,
      fontStyle: 'italic',
    }
  })

  return (
      <Document>
        <Page size={[200, 300]} style={styles.page}>
          <View style={styles.header}>
            <Text style={styles.restaurantName}>{tenantInfo?.businessSocial}</Text>
            <Text style={styles.ruc}>{tenantInfo?.document?.documentType}-{tenantInfo?.document?.document}</Text>
          </View>
          
          <View style={styles.divider} />
          
          <View style={styles.orderInfo}>
            <Text style={styles.orderNumber}>Comanda #{order.foodOrderCode || 'N/A'}</Text>
            <Text style={styles.tableInfo}>Mesa {order.foodTable?.name || 'N/A'}</Text>
          </View>
          
          <View style={styles.itemsContainer}>
            {order.items?.map((item, index) => (
              <View key={index} style={styles.itemRow}>
                <Text style={styles.itemName}>{item.name}</Text>
                <Text style={styles.itemQuantity}>x{item.quantity}</Text>
              </View>
            ))}
          </View>
        </Page>
      </Document>
  )
}

export default PdfFoodOrder
